import {Mushroom} from '@adv-mt/mushroom'

// Member access, not destructuring: Vite only replaces `process.env.NODE_ENV` literally, so a
// destructured `process.env` is `{}` in the browser and every client event went out with
// `environment: undefined`.
const NODE_ENV = process.env.NODE_ENV
const isServer = typeof window === 'undefined' ? 'true' : 'false'

export {createClientLogger} from './client.js'
export {createServerLogger, logErrorsMiddleware} from './server.js'
export {traceInitialProps} from './traceInitialProps.js'

export const initTracker = ({appName, environment, version, tenant, ...config}) => {
  const context = {environment: environment || NODE_ENV, isServer, version, tenant}

  Mushroom.start(appName, {
    ...config,
    context
  })
}
